module.exports = __webpack_public_path__ + "static/media/scenario.9416d484.svg";